// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
/* Custom class for MUI DatePicker styled like Bootstrap */
.bootstrap-datepicker .MuiInput-root {
  font-size: 1rem;
  font-family: var(--bs-body-font-family, system-ui);
  padding: 0.375rem 0;
  border-radius: 0;
  border-bottom: 1px solid #bfc6ce;
  box-shadow: none;
  background-color: #fff;
}

.bootstrap-datepicker .MuiInputBase-input {
  padding: 0;
  height: auto;
  line-height: 1.5;
}

.cursor-pointer {
  cursor: pointer;
}

.css-j7dxg2-MuiPickersSectionList-root-MuiPickersInputBase-sectionsContainer-MuiPickersFilledInput-sectionsContainer {
  padding: 0 !important;
  padding-top: 25px !important;
  padding-right: 12px !important;
  padding-left: 12px !important;
  padding-right: 0 !important;
}

.css-1t8kkt0.Mui-selected {
  background-color: var(--btnColor) !important;
}
.compact-form .MuiFormControl-root {
  font-size: 0.85rem;
}

.compact-form .MuiInputBase-input {
  padding: 6px -2px;
}
/* For all the options in the dropdown */
.MuiAutocomplete-option,
.MuiMenuItem-root {
  font-size: inherit !important;
}

/* For the selected value displayed in the input field */
.MuiAutocomplete-inputRoot,
.MuiAutocomplete-input {
  font-size: inherit !important;
}

/* Optional: if you have any additional labels or helper text */
.MuiInputLabel-root,
.MuiInputBase-input,
.MuiInputBase-root,
.MuiFormHelperText-root,
.MuiAutocomplete-listbox,
.MuiPopper-root,
.MuiFormLabel-root,
.MuiRadio-label,
.MuiAutocomplete-listbox li {
  font-size: inherit !important;
}

.org-card.highlighted {
  border: 2px solid #2c3e50;
}
@media print {
  @page {
    margin: 1cm;
    size: auto;
  }

  body {
    print-color-adjust: exact;
  }

  @page {
    margin: 0;
  }
}

.css-1kfabtt-MuiFormLabel-root-MuiInputLabel-root {
  top: -3px !important;
}

/* pagination css */
.MuiPaginationItem-root {
  color: var(--btnColor);
}

.MuiPaginationItem-root.Mui-selected {
  background-color: var(--btnColor);
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA,0DAA0D;AAC1D;EACE,eAAe;EACf,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA,wCAAwC;AACxC;;EAEE,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;;EAEE,6BAA6B;AAC/B;;AAEA,+DAA+D;AAC/D;;;;;;;;;EASE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n/* Custom class for MUI DatePicker styled like Bootstrap */\n.bootstrap-datepicker .MuiInput-root {\n  font-size: 1rem;\n  font-family: var(--bs-body-font-family, system-ui);\n  padding: 0.375rem 0;\n  border-radius: 0;\n  border-bottom: 1px solid #bfc6ce;\n  box-shadow: none;\n  background-color: #fff;\n}\n\n.bootstrap-datepicker .MuiInputBase-input {\n  padding: 0;\n  height: auto;\n  line-height: 1.5;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.css-j7dxg2-MuiPickersSectionList-root-MuiPickersInputBase-sectionsContainer-MuiPickersFilledInput-sectionsContainer {\n  padding: 0 !important;\n  padding-top: 25px !important;\n  padding-right: 12px !important;\n  padding-left: 12px !important;\n  padding-right: 0 !important;\n}\n\n.css-1t8kkt0.Mui-selected {\n  background-color: var(--btnColor) !important;\n}\n.compact-form .MuiFormControl-root {\n  font-size: 0.85rem;\n}\n\n.compact-form .MuiInputBase-input {\n  padding: 6px -2px;\n}\n/* For all the options in the dropdown */\n.MuiAutocomplete-option,\n.MuiMenuItem-root {\n  font-size: inherit !important;\n}\n\n/* For the selected value displayed in the input field */\n.MuiAutocomplete-inputRoot,\n.MuiAutocomplete-input {\n  font-size: inherit !important;\n}\n\n/* Optional: if you have any additional labels or helper text */\n.MuiInputLabel-root,\n.MuiInputBase-input,\n.MuiInputBase-root,\n.MuiFormHelperText-root,\n.MuiAutocomplete-listbox,\n.MuiPopper-root,\n.MuiFormLabel-root,\n.MuiRadio-label,\n.MuiAutocomplete-listbox li {\n  font-size: inherit !important;\n}\n\n.org-card.highlighted {\n  border: 2px solid #2c3e50;\n}\n@media print {\n  @page {\n    margin: 1cm;\n    size: auto;\n  }\n\n  body {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  @page {\n    margin: 0;\n  }\n}\n\n.css-1kfabtt-MuiFormLabel-root-MuiInputLabel-root {\n  top: -3px !important;\n}\n\n/* pagination css */\n.MuiPaginationItem-root {\n  color: var(--btnColor);\n}\n\n.MuiPaginationItem-root.Mui-selected {\n  background-color: var(--btnColor);\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
